export default __webpack_public_path__ + "media/images/mailer/icon_reply-a3b5dec5d57841934529545658d03490.png";